// frontend/src/components/common/Sidebar.js

import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function Sidebar({ isOpen }) {
  const { user } = useAuth();
  const location = useLocation();
  const isAdmin = user?.role === "Admin";
  const isManager = user?.role === "SM" || isAdmin;

  const navItems = [
    { path: "/dashboard", icon: "fa-th-large", label: "Dashboard" },
    { path: "/leads", icon: "fa-users", label: "My Leads" },
    { path: "/leads/add", icon: "fa-plus-circle", label: "New Lead" },
  ];

  const adminItems = [
    { path: "/admin/users", icon: "fa-user-cog", label: "Users" },
    { path: "/admin/dms", icon: "fa-server", label: "DMS Providers" },
    { path: "/admin/products", icon: "fa-boxes", label: "Products" },
    { path: "/admin/master", icon: "fa-database", label: "Master Data" },
    { path: "/admin/booking-apps", icon: "fa-database", label: "Booking Apps" },
  ];

  // EXACT active state matching
  const isActive = (path) => {
    // Dashboard - exact match only
    if (path === "/dashboard") {
      return location.pathname === "/dashboard";
    }
    // New Lead - exact match only
    if (path === "/leads/add") {
      return location.pathname === "/leads/add";
    }
    // My Leads - only when on /leads (not /leads/add or /leads/:id)
    if (path === "/leads") {
      // Don't highlight on /leads/add
      if (location.pathname === "/leads/add") return false;
      // Don't highlight on /leads/:id (edit/view)
      if (/^\/leads\/\d+/.test(location.pathname)) return false;
      return location.pathname === "/leads" || location.pathname === "/leads/";
    }
    // Admin paths
    if (path.startsWith("/admin/")) {
      return location.pathname === path || location.pathname.startsWith(path);
    }
    return location.pathname === path;
  };

  return (
    <aside className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      <div
        className="sidebar-brand"
        onClick={() => (window.location.href = "/dashboard")}
        role="button"
        tabIndex={0}
      >
        <div className="brand-lockup">
          <span className="brand-word">IVSG</span>
          <span className="brand-dot" />
          {/*<img src="/images/IVSG_new_logo_2026.png" alt="IVSG Logo" />*/}
        </div>
        <span className="brand-tagline">Smarter Tech. Smarter Customers™</span>
        <span className="portal-label">CRM PORTAL</span>
      </div>

      <div className="sidebar-divider" />

      <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-section-title">Workspace</div>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive(item.path) ? "active" : ""}`}
              end={
                item.path === "/dashboard" ||
                item.path === "/leads" ||
                item.path === "/leads/add"
              }
            >
              <span className="nav-icon">
                <i className={`fas ${item.icon}`} />
              </span>
              <span className="nav-label">{item.label}</span>
            </NavLink>
          ))}
        </div>

        {isManager && (
          <div className="nav-section admin-section">
            <div className="nav-section-title">Administration</div>
            {adminItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive(item.path) ? "active" : ""}`}
              >
                <span className="nav-icon">
                  <i className={`fas ${item.icon}`} />
                </span>
                <span className="nav-label">{item.label}</span>
              </NavLink>
            ))}
          </div>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="user-avatar">
            {user?.fullName?.charAt(0)?.toUpperCase() || "U"}
          </div>
          <div className="user-info">
            <strong>{user?.fullName || "User"}</strong>
            <span>{user?.role || "SR"}</span>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
